import { useNavigate } from 'react-router-dom';
import { useChartContext } from '../ChartContext';
import * as ChartUI from '../ChartUI';
import styled from 'styled-components';
import ChartHeaderIconActions from './ChartHeaderIconActions';
import ChartHeaderDisplay from './ChartHeaderDisplay';
import ChartHeaderBuilderInfo from './ChartHeaderBuilderInfo';
import ChartHeaderFavorite from './ChartHeaderFavorite';
import ChartHeaderDateRange from './ChartHeaderDateRange';
import ChartHeaderDescription from './ChartHeaderDescription';
import { useFullscreenContext } from '../../../utils/contexts/FullscreenContext';
import { useActionsVisibilityContext } from '../../ActionsVisibilityContext';

const Container = styled.div`
  display: flex;
  align-items: center;
`;
const DisplayWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
`;
const DragHandleContainer = styled.div`
  position: absolute;
  top: 14px;
  left: 4px;
`;

const ViewChartHeader = () => {
  const navigate = useNavigate();

  const { isFullScreen } = useFullscreenContext();
  const {
    metadata: { reportLink, mode, display, dragHandleElement, isEmbedded },
  } = useChartContext();
  const { actionsVisible } = useActionsVisibilityContext();

  const handleClick = () => {
    if (isEmbedded) {
      window.open(reportLink, '_blank');
      return;
    }
    navigate(reportLink);
  };

  return (
    <ChartUI.Header onClick={handleClick} $mode={mode}>
      {dragHandleElement && !isFullScreen && (
        <DragHandleContainer>{dragHandleElement}</DragHandleContainer>
      )}
      <Container>
        <DisplayWrapper>
          <ChartHeaderDisplay mode={mode} chartTitle={display} />
          {!isEmbedded && <ChartHeaderBuilderInfo />}
          {!isEmbedded && <ChartHeaderFavorite />}
        </DisplayWrapper>
        {(actionsVisible || isFullScreen || isEmbedded) && (
          <ChartHeaderIconActions />
        )}
      </Container>
      <ChartHeaderDateRange />
      <ChartHeaderDescription />
    </ChartUI.Header>
  );
};

export default ViewChartHeader;
